/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type {
  ISafe,
  ISafeInterface,
} from "../../../../contracts/periphery/SafeStorage.sol/ISafe";

const _abi = [
  {
    inputs: [],
    name: "domainSeparator",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class ISafe__factory {
  static readonly abi = _abi;
  static createInterface(): ISafeInterface {
    return new Interface(_abi) as ISafeInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): ISafe {
    return new Contract(address, _abi, runner) as unknown as ISafe;
  }
}
